(function(){
  if (window.__vpInit) return; window.__vpInit = true;
  var ARROW = "<svg class='vp-icon' viewBox='0 0 24 24' aria-hidden='true'><path d='M5 12h14M13 6l6 6-6 6'/></svg>";

  function reveal(root){
    var els = (root || document).querySelectorAll('.vp-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(x){ if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function(e){ if (e.dataset.delay) e.style.transitionDelay = e.dataset.delay + 'ms'; io.observe(e); });
  }

  /* Karussell: Pfeile + Punkte unter wischbaren Reihen (Handy) */
  function carousels(root){
    (root || document).querySelectorAll('.vp-cards, .vp-rev, .vp-steps, .vp-set').forEach(function(sc){
      if (sc.dataset.vpCar) return; sc.dataset.vpCar = '1';
      var items = Array.prototype.slice.call(sc.children);
      if (items.length < 2) return;
      var nav = document.createElement('div');
      nav.className = 'vp-car';
      nav.innerHTML = "<button type='button' class='vp-car__btn vp-car__prev' aria-label='Zur\u00fcck'>" + ARROW + "</button><div class='vp-car__dots'></div><button type='button' class='vp-car__btn vp-car__next' aria-label='Weiter'>" + ARROW + "</button>";
      sc.parentNode.insertBefore(nav, sc.nextSibling);
      var prev = nav.querySelector('.vp-car__prev'), next = nav.querySelector('.vp-car__next'), dotsEl = nav.querySelector('.vp-car__dots');
      var dots = items.map(function(it, i){
        var d = document.createElement('button'); d.type = 'button'; d.className = 'vp-car__dot'; d.setAttribute('aria-label', 'Karte ' + (i + 1));
        d.addEventListener('click', function(){ go(i); }); dotsEl.appendChild(d); return d;
      });
      function pos(i){ return items[i].offsetLeft - items[0].offsetLeft; }
      function cur(){
        var best = 0, min = Infinity;
        for (var i = 0; i < items.length; i++) { var dd = Math.abs(pos(i) - sc.scrollLeft); if (dd < min) { min = dd; best = i; } }
        return best;
      }
      function go(i){ i = Math.max(0, Math.min(items.length - 1, i)); sc.scrollTo({ left: pos(i), behavior: 'smooth' }); }
      prev.addEventListener('click', function(){ go(cur() - 1); });
      next.addEventListener('click', function(){ go(cur() + 1); });
      var ticking = false;
      function update(){
        ticking = false;
        var scrollable = sc.scrollWidth > sc.clientWidth + 4;
        nav.hidden = !scrollable;
        if (!scrollable) return;
        var c = cur();
        dots.forEach(function(d, i){ d.classList.toggle('is-active', i === c); });
        prev.disabled = sc.scrollLeft < 4;
        next.disabled = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4;
      }
      sc.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init(root){ reveal(root); carousels(root); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function(){ init(); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
